import { css } from "lit";

export const styles = css`
  .streaming-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    height: 100%;
    min-height: 0;
  }

  .streaming-header {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .live-badge {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    background: var(--sds-color-background-danger-default);
    color: white;
    border-radius: var(--sds-border-radius-pill);
    font: var(--sds-typography-weight-semibold) var(--sds-typography-scale-01) var(--sds-typography-family-body);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .live-badge.paused {
    background: var(--sds-color-background-warning-default);
  }

  .live-indicator {
    width: 8px;
    height: 8px;
    background: white;
    border-radius: 50%;
    animation: pulse 1.5s infinite;
  }

  .live-badge.paused .live-indicator {
    animation: none;
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }

  .duration {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
    font-variant-numeric: tabular-nums;
  }

  .video-container {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--sds-color-background-default-tertiary);
    border-radius: var(--sds-border-radius-03);
    overflow: hidden;
    min-height: 0;
  }

  .video-container stream-recorder {
    width: 100%;
    height: 100%;
  }

  .streaming-controls {
    display: flex;
    gap: 12px;
    justify-content: center;
    padding-top: 8px;
  }

  .error-banner {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: var(--sds-color-background-danger-subtle);
    color: var(--sds-color-text-danger-default);
    border-radius: var(--sds-border-radius-03);
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-01) var(--sds-typography-family-body);
  }

  .connecting-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 40px;
    color: var(--sds-color-text-default-secondary);
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-02) var(--sds-typography-family-body);
  }

  .spinner {
    width: 40px;
    height: 40px;
    border: 3px solid var(--sds-color-border-default-default);
    border-top-color: var(--sds-color-border-brand-default);
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 768px) {
    .streaming-content {
      padding: 8px;
      gap: 12px;
    }

    .video-container {
      border-radius: 0;
      margin: 0 -8px;
      width: calc(100% + 16px);
    }

    .streaming-controls {
      flex-direction: column;
      padding: 0 8px;
    }

    .streaming-controls wow-button {
      width: 100%;
    }
  }
`;
